import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: null,
  userDetails: null,
  isAuthenticated: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUserDetailsState: (state, action) => {
      state.userDetails = action.payload.details;
      state.token = action.payload.token;
      state.isAuthenticated = true;
    },
    clearUserDetailsState: (state) => {
      state.userDetails = null;
      state.token = null;
      state.isAuthenticated = false;
    },
    updateUserDetails: (state, action) => {
      state.userDetails = { ...state.userDetails, ...action.payload };
    },
  },
});

// Action creators are generated for each case reducer function
export const { 
  setUserDetailsState,
  clearUserDetailsState, 
  updateUserDetails  
} = authSlice.actions;
export const auth = (state) => state.auth;
export default authSlice.reducer;
